import type { RouteObject } from "react-router-dom";
import Home from "../pages/home/page";
import { Navigate } from "react-router-dom";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "*",
    element: <Navigate to="/" replace />,
  },
];

export default routes;
